var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=jm8y42ziic!../../node_modules/string-replace-webpack-plugin/loader.js?id=ilk81eo7m5!./twitchForm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21c6d168\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=jm8y42ziic!../../node_modules/string-replace-webpack-plugin/loader.js?id=ilk81eo7m5!./twitchForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/twitchForm.vue
// module id = 232
// module chunks = 1